import React, { useState, useCallback } from "react";
import { Card, Container, CssBaseline, Grid } from "@mui/material";
import httpclient from "../../Utils";
import Img from "../../Components/Images/synccare-2.png";
import { useBranch } from "../../Hooks/useBranch";
import LoginForm from "./LoginForm";
import { useNotification } from "../../Hooks/useNotification";
import { useApiErrorHandler } from "../../Hooks/useApiErrorHandler";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
    GRecaptchaResponse: "",
  });

  const { setCurrentBranch } = useBranch();
  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const handleKeyPassword = useCallback((e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  }, []);

  const handleSubmit = () => {
    setLoading(true);
    const formData = new FormData();

    formData.append("identity", loginData.username);
    formData.append("password", loginData.password);
    formData.append("GRecaptchaResponse", loginData.GRecaptchaResponse);
    formData.append("project_id", sessionStorage.getItem("project_id") || "");

    /**
     * Uncomment below line
     * pass this param on login if required to login to app
     */
    // formData.append("is_check_login", 1);

    httpclient
      .post(`login`, formData)
      .then(({ data }) => {
        if (data.status === 200) {
          sessionStorage.clear();
          localStorage.setItem("user", JSON.stringify(data.data.user));
          localStorage.setItem("token", JSON.stringify(data.data.access_token));

          setCurrentBranch(data.data.user.branch_code);

          showNotification("success", data.message);

          setTimeout(() => {
            /**
             * Uncomment below lines.
             * Redirect to port on which the app is running and pass access_token.
             *
             */

            // change port if running on different one
            // const NEW_PORT = 5173;
            // window.location.replace(
            //   `http://localhost:${NEW_PORT}/picker/?access_token=${encodeURIComponent(
            //     data.data.access_token
            //   )}`
            // );

            // comment below line if redirecting to app.
            window.location = "/";
          }, 1000);
        } else {
          showNotification("error", data.message);
        }
      })
      .catch((error) => handleApiError(error))
      .finally(() => setLoading(false));
  };

  const onCaptchaChange = useCallback((value) => {
    setLoginData((prevState) => ({
      ...prevState,
      GRecaptchaResponse: value,
    }));
  }, []);

  return (
    <div>
      <Container
        component="main"
        maxWidth="sm"
        style={{ textAlign: "center", marginTop: "120px" }}
      >
        <CssBaseline />
        <Card style={{ boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} textAlign="center">
              <img src={Img} alt="img" />
            </Grid>
            <Grid item xs={12}>
              <LoginForm
                loginData={loginData}
                handleChange={handleChange}
                handleKeyPassword={handleKeyPassword}
                onCaptchaChange={onCaptchaChange}
                handleSubmit={handleSubmit}
                loading={loading}
              />
            </Grid>
          </Grid>
        </Card>
      </Container>
    </div>
  );
};

export default Login;
